export const allUserGroupingData = {
    GET_AllUserGroupingData: "GET_AllUserGroupingData"
}